import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
export const formatDate = (date: any) => {
  return dayjs(date).format("DD MMM");
};

export const formatDateTime = (date: any) => {
  return dayjs(date).format("hh:mm A, MMM DD, YYYY");
};

export const formatDateTimeIncludesYear = (date: any) => {
  return dayjs(date).format("DD MMM YYYY, hh:mm A");
};

export const formatDateForNotification = (date: any) => {
  return dayjs(date).format("DD MMM");
};

export const formatTime = (date: any) => {
  return dayjs(date).format("hh:mm A");
};

export const formatETADateTime = (date: any) => {
  if (!date) return "N/A";
  try {
    return dayjs(date).format("hh:mm A - DD MMM");
  } catch (error) {
    return "N/A";
  }
};

export const dateFormatForApi = (date: any) => {
  return date.split("/").reverse().join("-");
};

export const dateFormatInvoiceApi = (date: any) => {
  return date.split("-").reverse().join("/");
};

export const dateToday = dayjs().format("DD MMM YY");
export const firstDateOfMonth = dayjs().startOf("month").format("DD MMM YY");

export const dateTodayApiFormat = dayjs().format("YYYY-MM-DD");

export const firstDateOfMonthApiFormat = dayjs()
  .startOf("month")
  .format("YYYY-MM-DD");

export const minusFiveMinutesFromCurrentTime = () =>
  dayjs().subtract(5, "minute").format("YYYY-MM-DDTHH:mm:ss");

export function dateSecondisBeforeDateFirst(firstDate: any, secondDate: any) {
  const newFirstDate = dayjs(firstDate);
  const newSecondDate = dayjs(secondDate);
  if (secondDate.length > 11) {
    return newSecondDate.isBefore(newFirstDate, "minute");
  } else {
    return newSecondDate.isBefore(newFirstDate, "day");
  }
}

export const findLatestETAWithGivenTime = (orderETA: any[]) => {
  return orderETA.reduce((latest, etaObj) => {
    const etaGivenTime = dayjs(etaObj.etaGivenTime);
    const eta = dayjs(etaObj.eta);

    if (!latest || etaGivenTime.isAfter(latest.latestGivenTime)) {
      return {
        latestTime: eta,
        latestGivenTime: etaGivenTime,
      };
    }

    return latest;
  }, null);
};

export const formatAfterDateTime = (date: any) => {
  const today = dayjs().startOf("day");
  const filterDate = dayjs(date);
  if (
    filterDate &&
    (filterDate.isAfter(today, "day") || filterDate.isBefore(today, "day"))
  ) {
    return formatDateTimeIncludesYear(date);
  }
  return formatTime(date);
};

export const formatAfterDateTimeWithoutMonth = (date: any) => {
  const today = dayjs().startOf("day");
  const filterDate = dayjs(date);
  if (
    filterDate &&
    (filterDate.isAfter(today, "day") || filterDate.isBefore(today, "day"))
  ) {
    return formatDate(date);
  } else {
    return "";
  }
};

export const formatInDateMonthYearUTC = (dateInput: any) => {
  const date = new Date(dateInput);

  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); 
  const year = date.getUTCFullYear().toString().slice(-2); 

  return `${day}-${month}-${year}`;
};

export const getCurrentUTCTimestamp = () => {
  return dayjs().utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
};

export const sortByDate = <T>(
  a: T,
  b: T,
  getDateA: (item: T) => any,
  getDateB: (item: T) => any,
  fallbackSort?: (a: T, b: T) => number
): number => {
  const dateA = getDateA(a);
  const dateB = getDateB(b);
  
  if (dateA && dateB) {
    try {
      const timeA = new Date(dateA);
      const timeB = new Date(dateB);
      
      if (isNaN(timeA.getTime()) && isNaN(timeB.getTime())) {
        return fallbackSort ? fallbackSort(a, b) : 0;
      }
      if (isNaN(timeA.getTime())) {
        return 1; 
      }
      if (isNaN(timeB.getTime())) {
        return -1; 
      }
      
      return timeA.getTime() - timeB.getTime();
    } catch (error) {
      return fallbackSort ? fallbackSort(a, b) : 0;
    }
  }
  
  if (dateA && !dateB) return -1;
  if (!dateA && dateB) return 1;
  
  return fallbackSort ? fallbackSort(a, b) : 0;
};

// Convert a date to a datetime-local compatible string in local timezone
// Shape: YYYY-MM-DDTHH:mm
export const toLocalDateTimeInput = (date: any) => {
  return dayjs(date).format("YYYY-MM-DDTHH:mm");
};
/**
 * Resolves and formats a date from mixed input sources into a short UI format.
 *
 * Examples:
 * "2024-09-18T10:30:00Z"  → "18 Sep 24"
 * "2024-09-18"           → "18 Sep 24"
 * new Date("2024-09-18") → "18 Sep 24"
 * 1726655400000          → "18 Sep 24"
 * "18/09/2024"           → "18 Sep 24"
 * null / undefined / ""  → "-"
 * "invalid-date"         → "-"
 *
 * Output format: DD MMM YY
 */
export const resolveAndFormatDate = (date?: string | Date) => {
    if (!date) return "-";

    if (
        typeof date === "string" &&
        date.includes("/") &&
        dayjs(date, "DD/MM/YYYY", true).isValid()
    ) {
        return dayjs(date, "DD/MM/YYYY").format("DD MMM YY");
    }

    if (dayjs(date).isValid()) {
        return dayjs(date).format("DD MMM YY");
    }

    return "-";
};
